import styled from 'styled-components';

import {
  SVG,
} from 'web-styled';

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    width: 16,
    height: 16,
    stroke: props.theme.colors.primary,
  }),
)`
`;

export const Dropdown = styled.div`
  min-width: 250px;
  padding: 8px 0;
  background: #fff;
  box-sizing: border-box;
  border: 1px solid rgba(0, 0, 0, .15);
  border-radius: 4px;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Item = styled.div`
  font-size: 14px;
  white-space: nowrap;
  padding: 3px 20px;
  cursor: pointer;
  position: relative;

  &:hover {
    color: #262626;
    background-color: #f5f5f5;
  }
  &:hover > button {
    opacity: 1;
  }
`;

export const AlternativesTrigger = styled.button`
  position: absolute;
  top: 3px;
  right: -22px;
  color: #fff !important;
  font-size: 10px;
  text-align: center;
  line-height: 16px;
  text-decoration: none !important;
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: 10px;
  cursor: pointer;
  background-color: ${props => props.theme.colors.primary} !important;
`;

export const Remove = styled.button`
  position: absolute;
  top: 5px;
  right: 4px;
  color: ${props => props.theme.colors.danger} !important;
  font-size: 14px;
  text-align: center;
  line-height: 16px;
  text-decoration: none !important;
  width: 16px;
  height: 16px;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
  cursor: pointer;
  opacity: 0;
`;
